"use strict";

document.documentElement.setAttribute('dir', document.body.className);

/****************************
 ****      Functions
 ****************************/
function initTooltips(){
    var tooltips = $('.tip');
    if (tooltips.length > 0) {
        $('.tip').tooltipster({
            theme: 'tooltipster-borderless',
            contentAsHTML: true,
            debug: false,
            delay: 100,
            functionInit: function(instance, helper){
                var $origin = $(helper.origin),
                    dataOptions = $origin.attr('data-tooltipster');
                if(dataOptions){
                    dataOptions = JSON.parse(dataOptions);
                    $.each(dataOptions, function(name, option){
                        instance.option(name, option);
                    });
                }
            }
        });
    }
}
// function addProductToCart(name, id){
//     $(document).find('.cart-items').append(
//         `
//         <div class="cart-item" data-id="${id}">
//             <button class="btn text-danger-30 text-hover-danger fs-16 p-0 mr-4 tip remove" title="Remove Item">
//                 <i class="fas fa-trash-alt"></i>
//             </button>
//             <div class="cart-item-details">
//                 <a href="#">
//                     <img src="http://placehold.jp/FF2751/ffffff/64x58.png" width="64" height="58" alt="Product Name">
//                 </a>
//                 <div class="flex-grow-1 ml-3">
//                     <a href="#" class="text-dark"><h4 class="fs-16 font-weight-semibold">${name}</h4></a>
//                     <div class="mt-2 d-flex align-items-center justify-content-between">
//                         <span class="text-alto font-weight-semibold">$30</span>
//                         <div class="cart-item-count">
//                             <button class="btn p-0 fas fa-minus-circle fs-16 text-alto text-hover-primary minus"></button>
//                             <input type="number" value="1" class="form-control qty" max="3" min="1" step="1">
//                             <button class="btn p-0 fas fa-plus-circle fs-16 text-alto text-hover-primary plus"></button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         `
//     )
// }

$(document).ready(function () {
    /****************************
     ****      Tooltips
     ****************************/
    initTooltips();

    /****************************
     ****      Multi Level Navbar
     ****************************/
    $("ul.dropdown-menu [data-toggle='dropdown']").on("click", function(event) {
        event.preventDefault();
        event.stopPropagation();
        $(this).siblings().toggleClass("show");
        if (!$(this).next().hasClass('show')) {
            $(this).parents('.dropdown-menu').first().find('.show').removeClass("show");
        }
        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function(e) {
            $('.dropdown-submenu .show').removeClass("show");
        });
    });

    /****************************
     ****      Form Actions
     ****************************/
    $(document).on('click', '.form-action', function () {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')){
            $(this).closest('.form-group').find('input').attr('type','text').focus();
        } else {
            $(this).closest('.form-group').find('input').attr('type','password').focus();
        }
    });

    /****************************
     ****      Sliders
     ****************************/
    if ($('.swiper-container').length) {
        var SliderAnimation = new SwiperAnimation();
        if ($('.home-swiper').length) {
            var SliderHome = new Swiper ('.home-swiper', {
                autoplay: true,
                slidesPerView: 1,
                loop: true,
                grabCursor: true,
                pagination: {
                    el: '.swiper-pagination-bullets',
                    clickable: true,
                },
                navigation: false,
                on: {
                    init: function () {
                        SliderAnimation.init(this).animate();
                    },
                    slideChange: function () {
                        SliderAnimation.init(this).animate();
                    }
                }
            });
        }
        if ($('.product-swiper').length) {
            var SliderProduct = new Swiper ('.product-swiper', {
                autoplay: true,
                slidesPerView: 1,
                loop: false,
                grabCursor: true,
                navigation: {
                    nextEl: '.swiper-button-next-icon',
                    prevEl: '.swiper-button-prev-icon',
                },
                on: {
                    init: function () {
                        SliderAnimation.init(this).animate();
                    },
                    slideChange: function () {
                        SliderAnimation.init(this).animate();
                    }
                }
            });
        }
    }

    /****************************
     ****      Add to Cart
     ****************************/
    // $(document).on( 'click', '.add-to-cart-btn', function() {
    //     var name = $(this).data('name');
    //     var id = parseFloat($(this).data('id'));
    //     addProductToCart(name,id);
    //     initTooltips();
    //     $('body').addClass('sidebar-active');
    // });
    /****************************
     ****      Cart
     ****************************/
    $(document).on( 'click', '.cart-toggle-btn', function() {
        $('body').toggleClass('sidebar-active');
    });
    $(document).mouseup(function(e){
        var container = $(".side-sidebar-wrap");
        if ($('body').hasClass('sidebar-active')){
            if ((!container.is(e.target) && container.has(e.target).length === 0)){
                $('body').removeClass('sidebar-active');
            }
        }
    });
    $(document).keyup(function (e) {
        if (e.keyCode === 27 && $('body').hasClass('sidebar-active')) {
            $('body').removeClass('sidebar-active');
        }
    });
    /****************************
     ****      Cart Items
     ****************************/
    $(document).on( 'click', '.cart-item-count .plus, .cart-item-count .minus', function() {
        var qty = $(this).closest('.cart-item-count').find('.qty');
        var val = parseFloat(qty.val());
        var max = parseFloat(qty.attr('max'));
        var min = parseFloat(qty.attr('min'));
        var step = parseFloat(qty.attr('step'));

        if ($(this).is('.plus')){
            if (max && (max <= val)) {
                qty.val(max);
            } else {
                qty.val(val + step);
            }
        } else {
            if (min && (min >= val)){
                qty.val(min);
            } else if (val > 1) {
                qty.val(val - step);
            }
        }
        qty.trigger('change');
    });
    $(document).on( 'click', '.cart-item .remove', function() {
        var item = $(this).closest('.cart-item');
        item.fadeOut(300, function() { item.remove(); });
    });

    // More than 7 menu items
    var navbar = document.querySelectorAll('.navbar-nav')[0];
    if (navbar.children.length > 7) {
        if (document.querySelectorAll('.navbar-nav').length > 1) {
            var backToDashboard = document.querySelectorAll('.navbar-nav')[1];
            var backToDashboardText = backToDashboard.querySelector('.nav-link').children[0].nextSibling;
            var backToDashboardTextTitle = String(backToDashboardText.textContent).replaceAll('\n', '').replaceAll('  ', '');
            backToDashboard.setAttribute('title', backToDashboardTextTitle);
            backToDashboard.classList.add('tip');
            backToDashboardText.remove();
        }
        navbar.classList.add('sm');
        initTooltips();
    }

});

/****************************
 ****      Listing Filters
 ****************************/

$(function () {
    var query_string = '';
    var current_url = window.location.href;
    $('body').on('click', '.sort-dir-desc', function (e) {
        var query_string = '';
        var sort_field = $('.sort-filter select').children(':selected').attr('value');
        if (current_url.indexOf('?') != -1)
            var query_string = current_url.slice(current_url.indexOf('?'));

        if (current_url.indexOf('sort') == -1)
            var link = current_url + '/sort:' + sort_field + '/direction:desc';
        else if (current_url.indexOf('sort') != -1) {
            link = current_url.replace(/sort:[^\/]*/g, 'sort:' + sort_field);
            link = link.replace(/direction:[^\/]*/g, 'direction:desc');
        }

        link = link.replace(query_string, '') + query_string;

        //                else
        //                    link = current_url + '&tag=' + tag_name + '&tag_type=' + item_type  ;
        //console.log(link);
        window.location.href = link;
    });

    $('body').on('click', '.sort-dir-asc', function (e) {
        var query_string = '';

        var sort_field = $('.sort-filter select').children(':selected').attr('value');
        if (current_url.indexOf('?') != -1)
            var query_string = current_url.slice(current_url.indexOf('?'));
        //console.log(sort_field);
        if (current_url.indexOf('sort') == -1)
            var link = current_url + '/sort:' + sort_field + '/direction:asc';
        else if (current_url.indexOf('sort') != -1) {
            var link = current_url.replace(/sort:[^\/]*/g, 'sort:' + sort_field);
            var link = link.replace(/direction:[^\/]*/g, 'direction:asc');
        }
        link = link.replace(query_string, '') + query_string

        //                else
        //                    link = current_url + '&tag=' + tag_name + '&tag_type=' + item_type  ;
        //console.log(link);
        window.location.href = link;
    });

    $('body').on('change', '.show-limit', function () {
        var query_string = '';

        var limit = $(this).children(':selected').text();
        //console.log(limit);
        if (current_url.indexOf('?') != -1)
            var query_string = current_url.slice(current_url.indexOf('?'));
        if (current_url.indexOf('limit') == -1) {

            var link = current_url + '/limit:' + limit;
        } else if (current_url.indexOf('limit') != -1) {
            var link = current_url.replace(/limit:[^\/]*/g, 'limit:' + limit);
        }
        var link = link.replace(query_string, '') + query_string;

        //                else
        //                    link = current_url + '&tag=' + tag_name + '&tag_type=' + item_type  ;
        //console.log(link);
        window.location.href = link;
    });
});

/****************************
 ****      Inputs
 ****************************/

const dateFormat = window.top.document.documentElement.dataset.siteData ? JSON.parse(window.top.document.documentElement.dataset.siteData).dateFormat : 'Y-m-d';

var formatDate = function () {
    var    token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZ]|"[^"]*"|'[^']*'/g,
        timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g,
        timezoneClip = /[^-+\dA-Z]/g,
        pad = function (val, len) {
            val = String(val);
            len = len || 2;
            while (val.length < len) val = "0" + val;
            return val;
        };

    // Regexes and supporting functions are cached through closure
    return function (date, mask, utc) {
        var dF = formatDate;

        // You can't provide utc if you skip other args (use the "UTC:" mask prefix)
        if (arguments.length == 1 && Object.prototype.toString.call(date) == "[object String]" && !/\d/.test(date)) {
            mask = date;
            date = undefined;
        }

        // Passing date through Date applies Date.parse, if necessary
        date = date ? new Date(date) : new Date;
        if (isNaN(date)) throw SyntaxError("invalid date");

        mask = String(dF.masks[mask] || mask || dF.masks["default"]);

        // Allow setting the utc argument via the mask
        if (mask.slice(0, 4) == "UTC:") {
            mask = mask.slice(4);
            utc = true;
        }

        var    _ = utc ? "getUTC" : "get",
            d = date[_ + "Date"](),
            D = date[_ + "Day"](),
            m = date[_ + "Month"](),
            y = date[_ + "FullYear"](),
            H = date[_ + "Hours"](),
            M = date[_ + "Minutes"](),
            s = date[_ + "Seconds"](),
            L = date[_ + "Milliseconds"](),
            o = utc ? 0 : date.getTimezoneOffset(),
            flags = {
                d:    d,
                dd:   pad(d),
                ddd:  dF.i18n.dayNames[D],
                dddd: dF.i18n.dayNames[D + 7],
                m:    m + 1,
                mm:   pad(m + 1),
                mmm:  dF.i18n.monthNames[m],
                mmmm: dF.i18n.monthNames[m + 12],
                yy:   String(y).slice(2),
                yyyy: y,
                h:    H % 12 || 12,
                hh:   pad(H % 12 || 12),
                H:    H,
                HH:   pad(H),
                M:    M,
                MM:   pad(M),
                s:    s,
                ss:   pad(s),
                l:    pad(L, 3),
                L:    pad(L > 99 ? Math.round(L / 10) : L),
                t:    H < 12 ? "a"  : "p",
                tt:   H < 12 ? "am" : "pm",
                T:    H < 12 ? "A"  : "P",
                TT:   H < 12 ? "AM" : "PM",
                Z:    utc ? "UTC" : (String(date).match(timezone) || [""]).pop().replace(timezoneClip, ""),
                o:    (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S:    ["th", "st", "nd", "rd"][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10]
            };

        return mask.replace(token, function ($0) {
            return $0 in flags ? flags[$0] : $0.slice(1, $0.length - 1);
        });
    };
}();

// Some common format strings
formatDate.masks = {
    "default":      "ddd mmm dd yyyy HH:MM:ss",
    shortDate:      "m/d/yy",
    mediumDate:     "mmm d, yyyy",
    longDate:       "mmmm d, yyyy",
    fullDate:       "dddd, mmmm d, yyyy",
    shortTime:      "h:MM TT",
    mediumTime:     "h:MM:ss TT",
    longTime:       "h:MM:ss TT Z",
    isoDate:        "yyyy-mm-dd",
    isoTime:        "HH:MM:ss",
    isoDateTime:    "yyyy-mm-dd'T'HH:MM:ss",
    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
};

// Internationalization strings
formatDate.i18n = {
    dayNames: [
        "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat",
        "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    ],
    monthNames: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
    ]
};

$('[data-date-range-input]').each(function () {
    var el = this;
    var name = el.dataset.dateRangeInput;
    var customizedDateFormat = () => {
        let customizedFormat = '';
        customizedFormat = dateFormat.replace('d', 'DD');
        customizedFormat = customizedFormat.replace('M', 'MMM');
        customizedFormat = customizedFormat.replace('m', 'MM');
        customizedFormat = customizedFormat.replace('y', 'YYYY');
        customizedFormat = customizedFormat.replace('Y', 'YYYY');
        customizedFormat = customizedFormat.replace('F', 'MMMM');
        return customizedFormat;
    }
    var options = {
        element: el,
        css: [
            "https://cdn.daftra.com/templates/shop_1/css/plugin_easepick-base.min.css",
            "https://cdn.daftra.com/templates/shop_1/css/plugin_easepick.min.css"
        ],
        setup(picker) {
            el.setAttribute('dir', 'ltr');
            el.classList.add('easepick-input');
            var hiddenInput = document.createElement('input');
            hiddenInput.setAttribute('type', 'hidden');
            hiddenInput.setAttribute('name', el.name);
            el.removeAttribute('name');
            if (el.value) {
                var val = formatDate(picker.getStartDate(), 'yyyy-mm-dd');
                if (!document.querySelector('[data-date-range-input-end="'+name+'"]')) {
                    val = val + ' - ' + formatDate(picker.getEndDate(), 'yyyy-mm-dd');
                }
                hiddenInput.value = val;
            }
            picker.on('select', () => {
                var val = formatDate(picker.getStartDate(), 'yyyy-mm-dd');
                if (!document.querySelector('[data-date-range-input-end="'+name+'"]')) {
                    val = val + ' - ' + formatDate(picker.getEndDate(), 'yyyy-mm-dd');
                }
                hiddenInput.value = val;
            });
            picker.on('clear', () => {
                hiddenInput.value = '';
            });
            el.parentNode.appendChild(hiddenInput);

            if (document.querySelector('[data-date-range-input-end="'+name+'"]')) {
                var endInput = document.querySelector('[data-date-range-input-end="'+name+'"]');
                endInput.classList.add('easepick-input');
                var hiddenInputEnd = document.createElement('input');
                hiddenInputEnd.setAttribute('type', 'hidden');
                hiddenInputEnd.setAttribute('name', endInput.name);
                endInput.removeAttribute('name');
                if (endInput.value) {
                    hiddenInputEnd.value = formatDate(picker.getEndDate(), 'yyyy-mm-dd');
                }
                picker.on('select', () => {
                    hiddenInputEnd.value = formatDate(picker.getEndDate(), 'yyyy-mm-dd');
                });
                picker.on('clear', () => {
                    hiddenInputEnd.value = '';
                });
                endInput.parentNode.appendChild(hiddenInputEnd);
            }

            if ($(document.body).hasClass('rtl')) {
                picker.Calendar.picker.ui.container.classList.add('rtl');
            }
        },
        zIndex: 10,
        format: customizedDateFormat(),
        grid: 2,
        firstDay: 6,
        clearButton: true,
        locale: { previousMonth: '<svg width="22" height="22" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><title/><path d="M39.3756,48.0022l30.47-25.39a6.0035,6.0035,0,0,0-7.6878-9.223L26.1563,43.3906a6.0092,6.0092,0,0,0,0,9.2231L62.1578,82.615a6.0035,6.0035,0,0,0,7.6878-9.2231Z"/></svg>', nextMonth: '<svg width="22" height="22" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><title/><path d="M69.8437,43.3876,33.8422,13.3863a6.0035,6.0035,0,0,0-7.6878,9.223l30.47,25.39-30.47,25.39a6.0035,6.0035,0,0,0,7.6878,9.2231L69.8437,52.6106a6.0091,6.0091,0,0,0,0-9.223Z"/></svg>' },
        calendars: 2,
        AmpPlugin: {
            resetButton: true
        },
        plugins: [
            "AmpPlugin",
            "RangePlugin"
        ]
    };
    if ($('[data-date-range-input-end="'+name+'"]').length) {
        if (typeof options['RangePlugin'] == 'undefined') {
            options['RangePlugin'] = {};
        }
        options['RangePlugin']['elementEnd'] = '[data-date-range-input-end="'+name+'"]';
    }
    new easepick.create(options);
});

if ($('[data-select-input]').length) {
    
    Selectize.define('persistent', function(options) {
        var self = this;
        self.on('focus', function() {
            var originalFocus = self.onFocus;
            return function(e) {
                var value = self.getItem(self.getValue()).text();
                self.clear(true);
                self.setTextboxValue(value);
                // self.$control_input.select();
                setTimeout( function () {
                    if (self.settings.selectOnTab) {
                        self.setActiveOption(self.getFirstItemMatchedByTextContent(value));
                    }
                    self.settings.score = null;
                }, 5);
                return originalFocus.apply(this, arguments);
            };
        }());

        self.onBlur = (function() {
            var originalBlur = self.onBlur;
            return function(e) {
                if (self.getValue() === "" && self.lastValidValue !== self.getValue()) {
                    self.setValue(self.lastValidValue);
                }
                setTimeout( function () {
                    self.settings.score = function() {
                        return function() {
                            return 1;
                        };
                    };
                }, 0 );
                return originalBlur.apply(this, arguments);
            }
        }());
        self.settings.score = function() {
            return function() { return 1; };
        };

    });

    Selectize.define("add_classes", function () {
        var self = this;
        self.on('initialize', () => {
            const template = self.$input.get(0).dataset.appFormSelectTemplate;
            self.$control.addClass(`${template ? 'template-' + template : ''}`);
        });
    });

    Selectize.define("auto_position", function (options) {
        var self = this;
        console.log();

        const POSITION = {
            top: 'top',
            bottom: 'bottom',
        };

        self.positionDropdown = (function() {
            return function() {
            const $control = this.$control;
            const offset = this.settings.dropdownParent === 'body' ? $control.offset() : $control.position();
            offset.top += $control.outerHeight(true);

            const dropdownHeight = this.$dropdown.prop('scrollHeight') + 5; // 5 - padding value;
            const controlPosTop = this.$control.get(0).getBoundingClientRect().top;
            const wrapperHeight = this.$wrapper.height();
            const position = controlPosTop + dropdownHeight + wrapperHeight  > window.innerHeight ? POSITION.top : POSITION.bottom;
            const styles = {
                left: offset.left
            };

            if (typeof options.width === 'undefined') {
                styles.width = $control.outerWidth();
            } else {
                styles.width = options.width;
            }

            if (position === POSITION.top) {
                Object.assign(styles, {bottom: offset.top, top: 'unset', margin: '0'});
                this.$dropdown.addClass('selectize-position-top');
            } else {
                Object.assign(styles, {top: offset.top, bottom: 'unset', margin: '0'});
                this.$dropdown.removeClass('selectize-position-top');
            }

            this.$dropdown.css(styles);
            }
        }());
    });

    Selectize.define('multiple_remove_button', function(options) {
        if (this.settings.mode !== 'single') {
            options = $.extend({
                    label     : '&times;',
                    title     : 'Remove',
                    className : 'remove',
                    append    : true
                }, options);

                var multiClose = function(thisRef, options) {

                    var self = thisRef;
                    var html = '<a href="javascript:void(0)" class="' + options.className + '" tabindex="-1" title="' + escapeHtml(options.title) + '"><i class="mdi mdi-close-thick"></i></a>';

                    /**
                     * Appends an element as a child (with raw HTML).
                     *
                     * @param {string} html_container
                     * @param {string} html_element
                     * @return {string}
                     */
                    var append = function(html_container, html_element) {
                        var pos = html_container.search(/(<\/[^>]+>\s*)$/);
                        return html_container.substring(0, pos) + html_element + html_container.substring(pos);
                    };

                    thisRef.setup = (function() {
                        var original = self.setup;
                        return function() {
                            // override the item rendering method to add the button to each
                            if (options.append) {
                                var render_item = self.settings.render.item;
                                self.settings.render.item = function(data) {
                                    return append(render_item.apply(thisRef, arguments), html);
                                };
                            }

                            original.apply(thisRef, arguments);

                            // add event listener
                            thisRef.$control.on('click', '.' + options.className, function(e) {
                                e.preventDefault();
                                if (self.isLocked) return;

                                var $item = $(e.currentTarget).parent();
                                self.setActiveItem($item);
                                if (self.deleteSelection()) {
                                    self.setCaret(self.items.length);
                                }
                                return false;
                            });

                        };
                    })();
                };

            // if (this.settings.mode === 'single') {
                // singleClose(this, options);
                // return;
            // } else {
                multiClose(this, options);
            // }
        }
    });

    Selectize.define("autofill_disable", function (options) {
        var self = this;
    
        self.setup = (function () {
        var original = self.setup;
        return function () {
            original.apply(self, arguments);
    
            // https://stackoverflow.com/questions/30053167/autocomplete-off-vs-false
            self.$control_input.attr({ autocomplete: "off", autofill: "no" });
        };
        })();
    });

    Selectize.define("append_values_to", function (options) {
        var self = this;
        const appendValues = () => {
            self.$control_input.attr('placeholder', self.settings.placeholder);
            $(options.selector).html('');
            const values = self.getValue();
            for (const id of values) {
                const selectedValueHtml = document.createElement('span');
                selectedValueHtml.classList.add('l-select-value', 'ui-select-value');
                const selectedValueTextHtml = document.createElement('span');
                selectedValueTextHtml.classList.add('ui-select-value-content');
                selectedValueTextHtml.innerText = Object.values(self.options).find((obj) => obj.value == id).text;
                const selectedValueRemoveIconHtml = document.createElement('i');
                selectedValueRemoveIconHtml.classList.add('ui-select-value-remove-icon', 'mdi', 'mdi-close-thick');
                selectedValueRemoveIconHtml.addEventListener('click', () => {
                    self.removeItem(id);
                });
                selectedValueHtml.appendChild(selectedValueTextHtml);
                selectedValueHtml.appendChild(selectedValueRemoveIconHtml);
                $(options.selector).append(selectedValueHtml);
            }
        }
        self.onChange = () => {
            appendValues();
        }
        self.on('initialize', () => {
            appendValues();
        });
    });

    Selectize.define("blank_option", function (options) {
        var self = this;
        self.on('change', () => {
            let values = self.getValue();
            if (!Array.isArray(values)) {
                values = [values];
            }
            const isBlankOption = values.find(id => id === '__blank__');
            if (isBlankOption) {
                self.setValue('');
            }
        });
    });

    Selectize.define("readonly", function (options) {
        var self = this;
        self.on('initialize', () => {
            if (self.$input.get(0).attributes.readonly) {
                self.lock();
            }
            self.$input.on('change', () => {
                if (self.$input.get(0).attributes.readonly) {
                    self.lock();
                } else {
                    self.unlock();
                }
            });
            self.on('change', () => {
                if (self.$input.get(0).attributes.readonly) {
                    self.lock();
                } else {
                    self.unlock();
                }
            });
        });
    });
    
    $('[data-select-input]').each(function () {
        var el = this;
        $(this).get(0).dataset.selectInputValue = $(this).val();
        $(this).selectize({
            onChange: (newValue) => {
                if (newValue !== $(this).get(0).dataset.selectInputValue) {
                    $(this).get(0).dataset.selectInputValue = newValue;
                    const event = new Event('change');
                    el.dispatchEvent(event);
                }
            },
            selectOnTab: true,
            highlight: false,
            plugins: {
                "autofill_disable": {},
                "multiple_remove_button": {},
                "auto_position": {},
                "add_classes": {},
                "blank_option": {},
                "readonly": {},
            }
        });        
    });
}

